import * as StaticsActions from './statics-actions';

export default (state = { }, action: any = {}) => {
    return action.type === StaticsActions.LOADED ? action.val : state;
};
